
import { useGenerateInitialResponse } from "./ai-response/use-generate-initial-response";
import { useRegenerateAIResponse } from "./ai-response/use-regenerate-ai-response";

export const useGenerateResponse = (id: string | undefined) => {
  const { 
    handleGenerateResponse, 
    isGenerating 
  } = useGenerateInitialResponse(id);
  
  const { 
    handleRegenerateAIResponse, 
    isRegenerating, 
    regeneratingMessageId 
  } = useRegenerateAIResponse(id);

  return {
    handleGenerateResponse,
    handleRegenerateAIResponse,
    isGenerating,
    isRegenerating,
    regeneratingMessageId
  };
};
